import { createGlobalState } from 'react-use';
import { UseMeasureRect } from 'react-use/lib/useMeasure';

export const useHeaderMeasure = createGlobalState<UseMeasureRect | null>(null);

export const useHeaderHeight = (): number => {
  const [measure] = useHeaderMeasure();
  return measure?.bottom || 0;
};
